import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import Pagination from "../../../../partials/content/Pagination";

function AllBanner() {
  const [allAdvertiseBannerUser, setAllAdvertiseBannerUser] = useState([]);
  const [allCampaignBanner, setAllCampaignBanner] = useState();
  const [showCampaign, setShowCampaign] = useState(false);
  const [showButtonAddAdvertise, setShowButtonAddAdvertise] = useState(false);
  const [campaignIDSelected, setCampaignIDSelected] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [advertiseIDSearchFilter, setAdvertiseIDSearchFilter] = useState();

  useEffect(() => {
    getAllAdvertiseBannerUser();
    getAllCampaignBanner();
  }, []);

  useEffect(() => {
    getAllAdvertiseBannerUser();
  }, [currentPage, countItemPerPage, advertiseIDSearchFilter]);

  const getAllAdvertiseBannerUser = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAllAdvertiseBannerUser =
      await sendRequestGetAllAdvertiseBannerUser(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultAllAdvertiseBannerUser) {
      return;
    }

    setAllAdvertiseBannerUser(
      resultAllAdvertiseBannerUser.advertises.reverse()
    );
    setCountPage(resultAllAdvertiseBannerUser.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (advertiseIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${advertiseIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
      case 3:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "ویرایش تبلیغ در حالت کمپین فعال";
        break;
    }

    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const sendRequestDeleteAdvertiseBannerUser = async (
    advertiseBannerUserID
  ) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/banner/" +
          advertiseBannerUserID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const deleteAdvertiseBannerUser = async (advertiseBannerUserID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    if (await sendRequestDeleteAdvertiseBannerUser(advertiseBannerUserID)) {
      await getAllAdvertiseBannerUser();
    }
  };

  const getAllCampaignBanner = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const getAllCampaignBanner = await sendRequestGetAllCampaignBanner();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!getAllCampaignBanner) {
      return;
    }
    setAllCampaignBanner(getAllCampaignBanner);
  };

  const sendRequestGetAllCampaignBanner = async () => {
    const headersRequest = getHeaderForRequest();
    let allCampaignBanner;
    try {
      allCampaignBanner = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/alternative/advertise",
        headersRequest
      );
    } catch (error) {
      return false;
    }
    return allCampaignBanner.data.data;
  };

  const generateAllAdvertiseBannerUserTag = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره تبلیغ</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setAdvertiseIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  id="site"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-1">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تبلیغ</td>
                <td>شماره کاربری</td>
                <td>شماره کمپین</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ بروزرسانی</td>
                <td>آدرس فرود</td>
                <td>وضعیت</td>
                <td>بررسی</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAdvertiseBannerUser.map((advertiseBannerUserTag, index) => {
                let classNameStateAdvertise = advertiseBannerUserTag.adv_active
                  ? "success"
                  : "danger";
                let textStateAdvertise = advertiseBannerUserTag.adv_active
                  ? "فعال"
                  : "غیر فعال";
                const [classNameConfirmAdvertise, textConfirmAdvertise] =
                  generateConfirmTag(advertiseBannerUserTag.adv_confirm);

                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUserTag.adv_id
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUserTag.adv_user_id
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUserTag.adv_campaign_id
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUserTag.adv_created_at
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUserTag.adv_updated_at
                      )}
                    </td>
                    <td className=" text-center">
                      <a
                        className="btn btn-primary text-center"
                        target="_blank"
                        href={advertiseBannerUserTag.link}
                      >
                        <i className="fa fa-globe"></i>
                      </a>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameStateAdvertise} `}
                        >
                          {textStateAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameConfirmAdvertise}`}
                        >
                          {textConfirmAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={
                              `/advertise/manage/banner/edit/` +
                              advertiseBannerUserTag.adv_id
                            }
                            className="btn btn-success  "
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </span>
                        <span>
                          <span
                            onClick={(e) => {
                              deleteAdvertiseBannerUser(
                                advertiseBannerUserTag.adv_id
                              );
                            }}
                            className="btn btn-danger  btn-danger"
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const sendRequestGetAllAdvertiseBannerUser = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let allAdvertiseBannerUser;
    try {
      allAdvertiseBannerUser = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/advertise/manage/banner/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAdvertiseBannerUser.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateAllCampaignBanner = () => {
    return allCampaignBanner.map((item) => {
      return <option value={item.id}>{item.title}</option>;
    });
  };

  const generateButtonAddAdvertiseAlternative = () => {
    return (
      <div>
        <div className="pt-3 d-flex">
          <span>
            <span
              onClick={(e) => {
                setShowCampaign((prevState) => !prevState);
              }}
              className="btn btn-success ml-2"
            >
              <span className="pl-2">
                <i className="fa fa-plus"></i>
              </span>
              <span>
                <span>اضافه کردن تبلیغ جدید جایگزین به کمپین</span>
              </span>
            </span>
          </span>
          <span
            className={`ml-2   ${showCampaign ? "d-flex" : "d-none"} `}
            id="select-campaign"
          >
            <span>
              <select
                className="form-control"
                onChange={(e) => {
                  const campaingID = parseInt(e.target.value);
                  if (!campaingID) {
                    setShowButtonAddAdvertise(false);
                    return;
                  }
                  setShowButtonAddAdvertise(true);
                  setCampaignIDSelected(campaingID);
                }}
              >
                <option value="0">کمپین خود را انتخاب کنید</option>
                {allCampaignBanner && generateAllCampaignBanner()}
              </select>
            </span>

            <span
              id="btn-add-advertise-banner"
              className={`pr-2 ${!showButtonAddAdvertise && "d-none"} `}
            >
              <Link
                to={`/advertise/banner/add/` + campaignIDSelected}
                className="btn btn-success"
              >
                اضافه کردن
              </Link>
            </span>
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-advertise" activeItem="all-advertise-banner" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">مدیریت تبلیغات بنری</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <Link
                  className="btn btn-danger mb-3"
                  to="/advertise/manage/banner/all/deleted"
                >
                  <span class="pl-2">
                    <i class="fa fa-trash"></i>
                  </span>
                  <span>
                    <span>تبلیغ های بنری حذف شده</span>
                  </span>
                </Link>
              </div>
              {allAdvertiseBannerUser.length == 0 &&
              advertiseIDSearchFilter == null ? (
                <></>
              ) : (
                generateAllAdvertiseBannerUserTag()
              )}

              <hr />
              {generateButtonAddAdvertiseAlternative()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllBanner;
